import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { DualAuthService } from '../services/DualAuthService';

// Guard that enforces employee (Azure AD) authentication
export const employeeGuard: CanActivateFn = (route, state) => {
  const auth = inject(DualAuthService);
  const router = inject(Router);
  if (auth.isEmployee()) {
    return true;
  }
  try {
    auth.loginEmployeeRedirect();
  } catch {
    // If redirect fails for some reason, navigate to employee login route
    router.navigate(['login/employee']);
  }
  return false;
};

